var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Machines",
    "data-name": "Logo Machines",
    width: 160,
    height: 35,
    viewBox: "0 0 158.676 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M231.08,0l-.158,8.054A6.241,6.241,0,0,1,236.51,5.27c3.638,0,6.535,2.176,6.535,7.522V25.439h-5.368V13.609c0-2.564-.9-3.925-3.165-3.925-3,0-3.59,2.256-3.59,5.3V25.439h-5.4l.158-22.246Z",
    transform: "translate(-154.249)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M321.236,21.926c0-1.676,0-3.51-.038-4.966h5.231a23.517,23.517,0,0,1,.208,2.511c.663-1.238,2.242-2.968,5.659-2.968,3.918,0,6.465,2.675,6.465,7.629v12.54h-5.4V24.738c0-2.216-.731-3.821-3.114-3.821-2.3,0-3.608,1.289-3.608,4.77V36.672h-5.4Z",
    transform: "translate(-219.691 -11.233)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M289.045,22.076v.515h1.6V37.646h5.4V17.934Z",
    transform: "translate(-197.699 -12.207)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M389.2,27.984c0,2.465,1.227,4.875,3.916,4.875,2.249,0,2.891-.912,3.4-2.1h5.406c-.692,2.413-2.822,6.376-8.951,6.376-6.426,0-9.214-4.855-9.214-10.027,0-6.183,3.141-10.6,9.407-10.6,6.7,0,8.978,4.9,8.978,9.818a12.254,12.254,0,0,1-.071,1.662Zm7.535-3.352c-.038-2.295-.945-4.226-3.577-4.226-2.588,0-3.63,1.8-3.845,4.226Z",
    transform: "translate(-262.479 -11.233)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M452.971,30.746c.409,1.57,1.678,2.452,3.693,2.452,1.994,0,2.721-.724,2.721-1.917,0-1.266-.838-1.762-3.633-2.455-6.355-1.583-7.4-3.571-7.4-6.353,0-2.9,2.026-5.97,7.911-5.97,5.918,0,7.92,3.265,8.089,5.935h-5.136c-.173-.728-.654-2.1-3.194-2.1-1.786,0-2.363.8-2.363,1.686,0,.981.606,1.455,3.773,2.2,6.509,1.53,7.43,3.785,7.43,6.674,0,3.264-2.457,6.235-8.406,6.235-5.922,0-8.368-2.889-8.8-6.383Z",
    transform: "translate(-306.191 -11.233)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M299.442,0H294V5.5L299.442,2.3Z",
    transform: "translate(-201.09)",
    fill: "#ff9d1d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M118.4,31.579V23.291c0-4.692-2.843-6.755-8.069-6.788-5.931-.034-8.075,2.8-8.368,6.3H107.1c.249-1.427.748-2.407,3.028-2.407,2.505,0,3,1.379,3,2.78v1.2h-2.784c-5.72,0-9.289,2.072-9.289,6.563,0,3.057,1.984,6.182,6.688,6.182,3.451,0,4.777-1.276,5.484-2.384a8.132,8.132,0,0,0,.273,1.927h5.212Zm-5.264-3.363c0,2.6-.422,5.015-3.854,5.015a2.516,2.516,0,0,1-2.808-2.629c0-1.9,1.207-2.9,4.462-2.9h2.2Z",
    transform: "translate(-69.12 -11.233)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M176.573,30.3a3.273,3.273,0,0,1-3.333,2.589c-2.365.034-3.845-1.913-3.845-6.109,0-3.822,1.4-5.939,3.868-6.009a3.074,3.074,0,0,1,3.343,2.728l5.024-1.429c-.683-2.382-2.884-5.569-8.263-5.569-5.938,0-9.453,4.636-9.453,10.457,0,5.924,3.122,10.17,9.194,10.17,4.987,0,7.377-2.607,8.38-5.421Z",
    transform: "translate(-112.113 -11.233)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M28.627,19.468A5.855,5.855,0,0,0,23.22,16.5c-3.418,0-6.051,1.727-6.714,2.965h0a5.559,5.559,0,0,0-2.853-2.508A6.945,6.945,0,0,0,11.1,16.5c-3.414,0-4.993,1.727-5.657,2.965h0a23.464,23.464,0,0,0-.208-2.508H0c.02.758.029,1.62.033,2.508,0,.817,0,1.656,0,2.459V36.672h5.4V25.687c0-3.481,1.313-4.77,3.608-4.77,2.338,0,3.084,1.546,3.111,3.7V36.672h5.4v-11.1c.028-3.4,1.336-4.66,3.606-4.66,2.383,0,3.114,1.605,3.114,3.821V36.672h5.4V24.132A9.422,9.422,0,0,0,28.627,19.468Z",
    transform: "translate(0 -11.233)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1",
    transform: "translate(44.935 28.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M142.188,89.65h2.064a3.105,3.105,0,0,1,3.3,3.115v.018a3.119,3.119,0,0,1-3.3,3.133h-2.064Zm.46.43v5.406h1.6a2.644,2.644,0,0,0,2.817-2.686v-.018a2.662,2.662,0,0,0-2.817-2.7Z",
    transform: "translate(-142.188 -89.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M164.1,89.65h4.411v.43h-3.951v2.461h3.552v.43h-3.552v2.515h4v.429H164.1Z",
    transform: "translate(-157.178 -89.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M198.827,92.571v-.018a3.134,3.134,0,0,1,3.1-3.24,3.254,3.254,0,0,1,2.41,1l-.328.34a2.831,2.831,0,0,0-2.091-.922,2.667,2.667,0,0,0-2.614,2.8v.018a2.69,2.69,0,0,0,2.622,2.819,2.827,2.827,0,0,0,2.135-.976l.31.3a3.256,3.256,0,0,1-2.462,1.092A3.1,3.1,0,0,1,198.827,92.571Z",
    transform: "translate(-180.928 -89.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M229.908,89.65h.461v2.9h3.968v-2.9h.46v6.265h-.46V92.98h-3.968v2.936h-.461Z",
    transform: "translate(-202.186 -89.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M261.942,89.51h.443l2.888,6.31h-.505l-.788-1.754h-3.659l-.788,1.754h-.478Zm1.842,4.135-1.63-3.625-1.639,3.625Z",
    transform: "translate(-222.121 -89.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M292.4,89.65h.434l4.278,5.451V89.65h.443v6.265h-.345l-4.367-5.567v5.567H292.4Z",
    transform: "translate(-244.932 -89.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M324.834,90.08h-2.162v-.43h4.784v.43h-2.162v5.836h-.46Z",
    transform: "translate(-265.634 -89.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M351.96,89.65h.461v6.265h-.461Z",
    transform: "translate(-285.666 -89.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M368.971,89.65h4.411v.43h-3.951v2.461h3.552v.43h-3.552v2.515h4v.429h-4.456Z",
    transform: "translate(-297.301 -89.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M397.277,89.65h2.6a2.428,2.428,0,0,1,1.745.618,1.662,1.662,0,0,1,.47,1.164v.018a1.831,1.831,0,0,1-1.816,1.79l2.046,2.676h-.585l-1.975-2.6h-2.029v2.6h-.461Zm2.551,3.249c1.036,0,1.807-.528,1.807-1.432v-.018c0-.841-.655-1.369-1.781-1.369h-2.117V92.9Z",
    transform: "translate(-316.662 -89.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M425.807,94.812l.3-.349a3,3,0,0,0,2.224.931c.93,0,1.568-.528,1.568-1.244v-.018c0-.662-.345-1.047-1.754-1.334-1.488-.3-2.091-.814-2.091-1.763v-.018a1.8,1.8,0,0,1,1.993-1.647,3.071,3.071,0,0,1,2.126.761l-.292.367a2.654,2.654,0,0,0-1.852-.707c-.912,0-1.515.528-1.515,1.182v.018c0,.662.337,1.065,1.807,1.37,1.435.3,2.037.815,2.037,1.727V94.1a1.827,1.827,0,0,1-2.055,1.71A3.512,3.512,0,0,1,425.807,94.812Z",
    transform: "translate(-336.176 -89.352)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "images/logo.f838e239.svg";
export { ForwardRef as ReactComponent };